"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpError = void 0;
var http_codes_1 = require("./http-codes");
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    function HttpError(definition) {
        // IF we have a message function in the type, we extract the argument type and set it has type of the second argument
        var ctx = [];
        for (
        // IF we have a message function in the type, we extract the argument type and set it has type of the second argument
        var _i = 1; 
        // IF we have a message function in the type, we extract the argument type and set it has type of the second argument
        _i < arguments.length; 
        // IF we have a message function in the type, we extract the argument type and set it has type of the second argument
        _i++) {
            // IF we have a message function in the type, we extract the argument type and set it has type of the second argument
            ctx[_i - 1] = arguments[_i];
        }
        var _this = this;
        var metadata = ctx[0];
        var message = typeof definition.message === 'function'
            ? definition.message(metadata)
            : definition.message;
        var httpMessage = http_codes_1.codes.get(definition.statusCode);
        _this = _super.call(this, message !== null && message !== void 0 ? message : httpMessage) || this;
        _this.name =
            httpMessage !== null && httpMessage !== void 0 ? httpMessage : 
            /* istanbul ignore next: should not happen */ 'Unknown code';
        _this.statusCode = definition.statusCode;
        _this.code = definition.code;
        _this.meta = metadata;
        _this.owner = 'Keplr';
        if (definition.headers) {
            _this.headers = definition.headers;
        }
        return _this;
    }
    return HttpError;
}(Error));
exports.HttpError = HttpError;
